export class UsefulWebsite {
    UrlId: number;
    Url: string;
    UrlText: string;
}



// WEBPACK FOOTER //
// ./src/app/models/useful-website.ts